// UAE agent commission model shown on /uae (ID-126). TODO(ID-110): the UAE commission settings become the source of truth.
export type UaeModel = {
  agentPercentBeforeCap: number;
  agentPercentAfterCap: number;
  capAed: number;
  /** Cap year length; it always starts on the platform join date (owner answer 15). */
  cycleMonths: number;
  /** Open owner question: the brief's distress-deal claims ("verified by our team", "new deals every week", …). Off = neutral copy. */
  distressClaimsExtended: boolean;
};

export const UAE_MODEL_DEFAULTS: Readonly<UaeModel> = Object.freeze({
  agentPercentBeforeCap: 90,
  agentPercentAfterCap: 100,
  capAed: 400000,
  cycleMonths: 12,
  distressClaimsExtended: false,
});

export const UAE_MODEL_LIMITS = {
  percentMin: 0,
  percentMax: 100,
  capMaxAed: 100_000_000,
  cycleMonthsMin: 1,
  cycleMonthsMax: 60,
} as const;

// Public /api/public/uae-model CDN cache window (AC 11.8: new figures within 10 minutes).
export const UAE_MODEL_CACHE_SECONDS = 600;

// Commission calculator (AC 4.2 / 4.7); range and default per ID-130.
export const UAE_CALCULATOR = {
  min: 10_000,
  max: 500_000,
  step: 5_000,
  pageStep: 50_000,
  defaultValue: 50_000,
} as const;

// Agreement v3 clauses 5.2/5.3: flat admin fees per deal fully after the cap (public /uae defaults).
export const UAE_ADMIN_FEE_SALE_AED = 1_850;
export const UAE_ADMIN_FEE_RENTAL_AED = 500;

// Agreement v3 clause 5.1: annual service fee taken in instalments on the cap year's first sales.
export const UAE_SERVICE_FEE_INSTALMENT_AED = 1_000;
export const UAE_SERVICE_FEE_INSTALMENTS = 3;

// Market facts (not the Insiders model): the split UAE agents typically close at elsewhere, and the
// agent share on developer-exclusive projects (exclusive terms, independent of the cap).
export const UAE_TYPICAL_MARKET_PERCENT = 90;
export const UAE_EXCLUSIVE_AGENT_PERCENT = 100;

// FastPay (any deal, before or after the cap) takes this many points off the split: 90% → 80%, 100% → 90%.
export const UAE_FASTPAY_DEDUCTION_POINTS = 10;

// Top of the International referral ladder that UAE partners use (owner answer #2).
export const UAE_PARTNER_MAX_PERCENT_DEFAULT = 50;
